module.exports = __webpack_public_path__ + "static/media/speech_12.39708790.svg";